import type {
  ReportDataField,
  ReportDataFieldRaw,
  ReportDataTemplate,
} from '../_types';

export const deriveTemplates = (fields: ReportDataFieldRaw[]): ReportDataTemplate[] => {
  const byTemplate = new Map<number, ReportDataTemplate>();

  fields.forEach((field) => {
    if (!byTemplate.has(field.templateId)) {
      byTemplate.set(field.templateId, {
        id: field.templateId,
        name: field.templateName,
      });
    }
  });

  return Array.from(byTemplate.values()).sort((a, b) => a.name.localeCompare(b.name));
};

export const deriveFields = (fields: ReportDataFieldRaw[]): ReportDataField[] => {
  const byField = new Map<number, ReportDataField>();

  fields.forEach((field) => {
    const existing = byField.get(field.fieldId);
    if (existing) {
      if (!existing.templateIds.includes(field.templateId)) {
        existing.templateIds.push(field.templateId);
      }
      return;
    }

    byField.set(field.fieldId, {
      id: field.fieldId,
      label: field.agencyLabel || field.fieldName,
      templateIds: [field.templateId],
    });
  });

  return Array.from(byField.values()).sort((a, b) => a.label.localeCompare(b.label));
};
